module.exports = __webpack_public_path__ + "static/media/ico-attachment.99f00eea.svg";